/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_DetailsInputs */

const en_pronunciation_report_details = /** @type {(inputs: Pronunciation_Report_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anything else?`)
};

const es_pronunciation_report_details = /** @type {(inputs: Pronunciation_Report_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Algo más?`)
};

/**
* | output |
* | --- |
* | "Anything else?" |
*
* @param {Pronunciation_Report_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_details = /** @type {((inputs?: Pronunciation_Report_DetailsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_DetailsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_details(inputs)
	return en_pronunciation_report_details(inputs)
});